import Search from '../algolia/components/Search'
import { SearchInfoProps } from './index.sync'
import { Component } from 'preact'
import classNames from 'classnames'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import Button from '../../control-components/ui-components/Button'

interface Props {
  searchInfo: SearchInfoProps
  isUserGuest: boolean
  enableFocusToSearch: boolean
  enableExtendedSearch: () => void
  disableExtendedSearch: () => void
  displayFilters?: boolean
  extendSearch: boolean
}

interface State {
  isFiltersOverlay: boolean
  enableFocusToSearch: boolean
}

class MegaMenuSearch extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      isFiltersOverlay: false,
      enableFocusToSearch: false
    }
  }

  resetFilters (e: Event) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('resetFilters'))
  }

  revertFilters (e: Event) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('revertFilters'))
    this.filtersOverlayHandler(e, false)
  }

  filtersOverlayHandler (e: Event, value: boolean) {
    e.stopPropagation()
    e.preventDefault()

    window.dispatchEvent(new CustomEvent('filter', {
      detail: {
        display: value
      }
    }))

    if (value) {
      this.setState({
        isFiltersOverlay: value
      })
    } else {
      /*
        Items that should be in the filters are added via Portal component
        having setTimeout here is making state change async and give time to filter component to unmount
      */
      window.setTimeout(() => {
        this.setState({
          isFiltersOverlay: !this.state.isFiltersOverlay
        })
      }, 0)
    }

    const bodyEl = document.querySelector('body')

    if (bodyEl) {
      if (bodyEl.style.overflow === 'hidden') {
        bodyEl.style.overflow = 'visible'
      } else {
        bodyEl.style.overflow = 'hidden'
      }
    }
  }

  render ({ isUserGuest, extendSearch, searchInfo, enableFocusToSearch, displayFilters, disableExtendedSearch, enableExtendedSearch }: Props,
    { isFiltersOverlay }: State) {
    return (
      <div className={classNames('header-navigation_extendable-search', { extended: extendSearch })}>
        <div className={classNames('header-navigation_extended-search', { 'is-hidden': !extendSearch })}>
          <form>
            <Search
              {...searchInfo}
              isUserGuest={isUserGuest}
              enableFocusToSearch={enableFocusToSearch}
              callbackOnOutsideClick={disableExtendedSearch}
            />
          </form>
        </div>
        <button
          type='button'
          className={classNames('btn btn--secondary search-icon header-navigation_extendable-search-icon', { 'is-hidden': extendSearch })}
          onClick={enableExtendedSearch}
        >
          <Icon icon='search' width={16} height={16} />
        </button>
        {displayFilters && (
          <button
            className='instant-search__filter is-hidden-S'
            onClick={(e: Event) => this.filtersOverlayHandler(e, true)}
          >
            <Icon width={18} height={12} color='#6B707E' icon='filter' />
          </button>
        )}
        {isFiltersOverlay && (
          <div className='instant-search__results-wrapper is-hidden-L'>
            <div className={classNames('instant-search__results-wrapper-filter', { 'instant-search__results-wrapper-filter--hide': !isFiltersOverlay })}>
              <div className='instant-search__results-wrapper-filter-header'>
                <Icon icon='close' onClick={(e) => this.revertFilters(e)} />
                <h3
                  className='instant-search__results-wrapper-filter-header-heading'
                >
                  <Phrase p='advanced.search.filters' />
                </h3>
                <button
                  onClick={(e) => this.resetFilters(e)}
                  className='instant-search__results-wrapper-filter-header-btn'
                >
                  <Phrase m='Common' p='advanced.search.filter.clear.all' />
                </button>
              </div>
              {
                    /*
                    * Filters can be added via Portal component from real place of filters.
                    * Since Search does not include them it does not care about which items needs to be display in which order,
                    * all those decisions can be done on filter component
                                    * */
                  }
              <div className='instant-search__results-wrapper-filters' />
              <div className='instant-search__results-wrapper-filter-show-more-wrapper'>
                <Button
                  cta
                  class='instant-search__results-wrapper-filter-show-more'
                  onClick={(e: Event) => this.filtersOverlayHandler(e, false)}
                >
                  <Phrase p='show.results' />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default MegaMenuSearch
